<template lang="pug">
  .columns
    .column.is-12.has-text-centered
      table#tbItems.table.is-striped.is-responsive
        thead
          tr
            th.has-text-centered #
            th.has-text-centered Descripción
            th.has-text-centered Ubicación
            th.has-text-centered Concepto
            th.has-text-centered Importe
            th.has-text-centered(colspan=3) Seleccionar
        tbody
          tr(v-for="(i, index) in items")
            td
              span.tag.is-black {{ index + 1 }}
              | &nbsp
              a.button.is-small.is-rounded(:href='getRuta(i.file)' target='_blank' rel='noreferer noopener')
                i.fas.fa-file-pdf
            td
              a.button.is-small.is-rounded.is-noBordered(@click='showHideData(i)')
                i.fas.fa-angle-right 
              | &nbsp{{ i.descripcion }}
            td {{ i.ubicacion }}
            td(v-html='getConcepto(i.concepto)') 
            td {{ i.total | currency }}
            td
              .field
                input.is-checkradio(type='checkbox' v-model="itemsArraySel" :value="i" :id="index" @click='changeClass(index)')
                label(:for="index") &nbsp
            td 
              .field
                .control
                  input.input.is-primary.is-hidden(
                    type='text', 
                    placeholder='Num. Partida',
                    ref="inputPartida"
                  )
            td 
              .field
                .control
                  input.input.is-primary.is-hidden(
                    type='text', 
                    placeholder='Observaciones'
                    ref="inputObservaciones"
                  )
</template>

<script>
  export default {
    name: 'ListPresupuestos',
    props: {
      cotizaciones: {
        type: Array,
        default: () => []
      },
      cotizacionesSel: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        items: [],
        itemsArraySel: []
      }
    },
    watch: {
      itemsArraySel() {
        this.$emit('countItems', this.itemsArraySel)
      },
      cotizaciones () {
        this.items.length = 0
        this.items = this.cotizaciones
      },
      cotizacionesSel () {
        this.checkItemsSelected()
      },
    },
    methods: {
      checkItemsSelected() {
        if (this.cotizaciones.length > 0 && this.cotizacionesSel.length > 0) {
          this.cotizacionesSel.map( itemSel => {
            let exist = {}
            if (exist = this.cotizaciones.find( pres => pres.id === itemSel.id)) {
              this.itemsArraySel.push(exist)
            }
          })
        }
      },
      getRuta(ruta) {
        const currentUrl = window.location.hostname

        return `https://${currentUrl}${ruta}`
      },
      getConcepto (concepto) {

        switch (concepto) {
          case 0:
            return "<span class='tag is-dark'>G. Admin.</span>"
          case 1:
            return "<span class='tag is-dark'>G. Op.</span>"
          case 2:
            return "<span class='tag is-dark'>G. Seg.</span>"
          case 3:
            return "<span class='tag is-dark'>G. Mtto. Prev.</span>"
          case 4:
            return "<span class='tag is-dark'>G. Mantto. Correc.</span>"
          case 5:
            return "<span class='tag is-dark'>G. Admin. (OPS)</span>"
          case 6:
            return "<span class='tag is-dark'>G. Inst. y Sist</span>"
          case 7:
            return "<span class='tag is-dark'>Nuevos Proy.</span>"
        }
      },
      changeClass (index) {
        this.$refs.inputObservaciones[index].classList.toggle('is-hidden')
        this.$refs.inputPartida[index].classList.toggle('is-hidden')
      },
      showHideData(cot) {
        this.$emit('showCotData', cot)
      }
    },
  }
</script>

<style lang="scss" scoped>
  .is-noBordered {
    border: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/presupuestos_Componentes/componentes/ListCot_Presupuestos.vue